import * as React from "react";

const SvgRightArrow = props => <svg viewBox="0 0 24 24" height={48} width={48} xmlns="http://www.w3.org/2000/svg" {...props}><path d="M23.243 12L0.757 12" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" /><path d="M11.257,23,22.9,12.751a1,1,0,0,0,0-1.5L11.257,1" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" /></svg>;

export default SvgRightArrow;